// この middleware が設定されている場合は要ログイン
export default defineNuxtRouteMiddleware(async (to) => {
  // クライアントだけで実行する
  if (import.meta.client) {
    const { currentUser } = useAuth();

    if (!currentUser.value && to.path !== '/login') {
      const path = '/login';
      return navigateTo(path);
    }
  }
});
